import { Navigate } from "react-router-dom";
import { useToken } from "./tokenContext";
import { useFeature } from "./featureContext";
import LoadingSkeleton from "../components/loading";
import PropTypes from "prop-types";

const ProtectedRoute = ({ children, module, action, feature, features }) => {
  const hasToken = localStorage.getItem("token");
  const { hasPermission, loading: tokenLoading } = useToken();
  const { hasFeatureBySlug, loading: featureLoading } = useFeature();

  if (!hasToken) {
    return <Navigate to="/login" replace />;
  }

  if (tokenLoading || featureLoading) {
    return <LoadingSkeleton />;
  }

  if (feature && !hasFeatureBySlug(feature)) {
    return <Navigate to="/semPermissao" replace />;
  }

  if (features?.length && !features.some((f) => hasFeatureBySlug(f))) {
    return <Navigate to="/semPermissao" replace />;
  }

  if (!hasPermission(module, action)) {
    return <Navigate to="/semPermissao" replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node,
  module: PropTypes.string,
  action: PropTypes.string,
  feature: PropTypes.string,
  features: PropTypes.arrayOf(PropTypes.string),
};

export default ProtectedRoute;
